import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Button,
  useTheme,
  Typography,
} from '@mui/material';
import { ScheduleDetailEditor } from './schedule-detail-editor';
import {
  EnumScheduleType,
  ThermostatPendingSchedule,
  ThermostatScheduleTemplateValue,
} from '../../../../../types/generated-types';
import { EmptyWeeklySchedule } from '../../../devices/residential-devices/thermostat/types';
import _ from 'lodash';
import { SetpointLimitSettings } from '../../types/setpointLimitSettings';

export const ThermostatEditPendingScheduleDialog = ({
  open,
  handleClose,
  scheduleValues,
  pendingScheduleHasChanges,
  setScheduleValues,
  setScheduleType,
  scheduleType,
  setpointLimitSettings,
  handleUpdatePendingSchedule,
}: {
  open: boolean;
  handleClose: () => void;
  scheduleValues:
    | ThermostatScheduleTemplateValue
    | ThermostatPendingSchedule
    | null;
  setScheduleValues: (
    schedule: ThermostatScheduleTemplateValue | ThermostatPendingSchedule,
  ) => void;
  handleUpdatePendingSchedule: () => void;
  setScheduleType: (newScheduleType: EnumScheduleType) => void;
  setpointLimitSettings?: SetpointLimitSettings;
  scheduleType: EnumScheduleType;
  pendingScheduleHasChanges: boolean;
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        alignItems: 'stretch',
        margin: 0,
        '& .css-1t1j96h-MuiPaper-root-MuiDialog-paper': {
          margin: 0,
          width: '100%',
        },
      }}
    >
      <DialogContent sx={{ padding: '20px 10px' }}>
        <Typography variant="h3">Edit Pending Schedule</Typography>
        <br />
        {scheduleValues !== null &&
        !_.isEqual(scheduleValues.value, EmptyWeeklySchedule) ? (
          <ScheduleDetailEditor
            scheduleValues={scheduleValues}
            scheduleType={scheduleType}
            setScheduleType={setScheduleType}
            setScheduleValues={setScheduleValues}
            setpointLimitSettings={setpointLimitSettings}
          />
        ) : (
          <div>No Pending Schedule Available </div>
        )}
      </DialogContent>
      <DialogActions>
        <Grid container rowSpacing={1} direction={'row'}>
          <Grid item xs={12}>
            <Button
              variant="contained"
              fullWidth
              disabled={!pendingScheduleHasChanges}
              color={'info'}
              sx={{ color: '#fff' }}
              onClick={() => {
                handleUpdatePendingSchedule();
              }}
            >
              Update Pending Schedule
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Button
              fullWidth
              sx={{ color: theme.embue.bad }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleClose();
              }}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};
